import React, {useEffect, useState} from 'react';
import Images from "../../assets/images/images";
import Row from "../UI/Row";
import NavLink from "./NavLink";
import {MdClose} from "react-icons/md";
import {BiMenu} from "react-icons/bi";
import BurgerLink from "./BurgerLink";
import {useLocation, useNavigate} from "react-router-dom";

const DashboardHeader = () => {

    const { pathname } = useLocation();

    const [menuOpen, setMenuOpen] = useState(false);
    const [isLogged, setIsLogged] = useState(false);

    const navigate = useNavigate();

    const goToHome = () => {
        window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN;
    }

    const logout = () => {
        sessionStorage.setItem('@user_token', '');
        navigate('../login');
    }

    const login = () => {
        sessionStorage.setItem('@user_token', '');
        window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN + '/app/login';
    }

    useEffect(() => {
        const load = () => {
            let token = sessionStorage.getItem('@user_token');
            if(token) {
                setIsLogged(true);
            } else {
                setIsLogged(false);
            }

        }

        load();
    }, [pathname]);

    return (
        <div
            className="sticky top-0  w-full shadow-xl z-20">
            <div className="flex flex-row justify-center px-4 bg-gradient-to-r from-ea_green_from to-ea_green_to">
                <div className="w-full flex flex-row justify-between items-center md:items-start" style={{maxWidth: "1200px"}}>
                    <div className="flex flex-col items-center justify-center cursor-pointer" title="Torna alla Home"
                         onClick={goToHome}>
                        <img src={Images.headerLogo} alt="logo" className="h-12 my-2 md:h-12"/>
                    </div>
                    <Row className="text-white gap-8 hidden md:flex">
                        <NavLink to="/" >Home</NavLink>
                        <NavLink onClick={logout} current={"logout"}>Esci</NavLink>
                        {/*<NavLink to="/app/login" current={current}>Accedi</NavLink>*/}
                    </Row>

                    <div onClick={() => setMenuOpen(!menuOpen)} className="block md:hidden text-2xl cursor-pointer text-white">
                        {menuOpen ?
                            <MdClose/>
                            :
                            <BiMenu />}
                    </div>
                </div>
            </div>
            {menuOpen && <div className="bg-white w-full ">
                <BurgerLink to="/">Home</BurgerLink>
                {isLogged ?
                    <BurgerLink onClick={logout}>Esci</BurgerLink>
                    :
                    <BurgerLink onClick={login}>Accedi</BurgerLink>
                }

                {/*<BurgerLink current={current} to="/app/login">Accedi</BurgerLink>*/}
            </div>}

        </div>
    );
};

export default DashboardHeader;